import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import watsapp from '../assets/watsapp.png';
import linkedin from '../assets/linkedin.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import databricks from '../assets/databricks.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import azure from '../assets/azure.png';
import python from '../assets/python.png';
import devops from '../assets/devops.png';
import redux from '../assets/redux.png';
import snowflake from '../assets/snowflake.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';


import nb from '../assets/nb.png';



export default {
  email,
  mobile,
  watsapp,
  linkedin,
  api,
  cpp,
  css,
  databricks,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  azure,
  python,
  devops,
  redux,
  snowflake,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  nb,

 
};